import './Footer.scss'
import Footer from "./Footer";

export default Footer